import Text16 from './Text16'
export default Text16
